import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Typography,
  Collapse,
  Button,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Select,
  DatePicker,
  InputNumber,
  Input,
  Tooltip,
} from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import { useNavigate } from "react-router-dom";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const EditKYCBusinessInfo = (props) => {
  const {
    currentCustomerObj,
    userData,
    refreshList,
    customerDetails,
    creditRatingOptions,
    useForm,
  } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    formValues.externalId = currentCustomerObj.id;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.isCustomerDirector = formValues.directorCustomer;
    formValues.hasEstablishedRelationship = formValues.establishedRelationship;
    formValues.expiryDate = formValues.expiryDate
      ? BOM.DateTime(formValues.expiryDate, "only-date")
      : BOM.DateTime(customerDetails?.expiryDate, "only-date");

    delete formValues.directorCustomer;
    delete formValues.establishedRelationship;

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}`;

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateKycMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      }
    );
  };
  return (
    <>
      {BOM.HasPermission("CREATE_CLIENT_LIMIT") && (
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          style={{
            marginLeft: "auto",
          }}
          onClick={showModal}
        >
          <EditOutlined />
          &nbsp;{labelConfig.edit}
        </Button>
      )}
      <Modal
        title="Edit KYC info"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            initialValues={{
              unAuthorisedLimit: 0,
              utilizedLimit: 0,
              unUsedLimit: 0,
              digitsAfterDecimal: 2,
              inMultiplesOf: 100,
            }}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">
          <Row>
            <Divider orientation="left">Business Information</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.centralBankIndustryCode}
                name="centralBankIndustryCode"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.centralBankIndustryCode
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.economicActivityCode}
                name="economicActivityCode"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.economicActivityCode
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.annualTurnover}
                name="annualTurnover"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.annualTurnover
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.retailFlag} name="isRetail">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.retailFlag} *`,
                    "select"
                  )}
                  options={staticConfig.trueOrFalseData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.smeFlag} name="isSme">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.smeFlag} *`,
                    "select"
                  )}
                  options={staticConfig.trueOrFalseData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.interCompanyFlag}
                name="isInterCompany"
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.interCompanyFlag} *`,
                    "select"
                  )}
                  options={staticConfig.trueOrFalseData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.shortAndLongTermRating}
                name="termRating"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.shortAndLongTermRating
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.creditRating} name="creditRating">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.creditRating} *`,
                    "select"
                  )}
                  options={creditRatingOptions}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.centralGovernmentRatingIndicator}>
                    {BOM.SubstringFormat(
                      labelConfig.centralGovernmentRatingIndicator,
                      20
                    )}
                  </Tooltip>
                }
                name="centralGovernmentRated"
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.centralGovernmentRatingIndicator} *`,
                    "select"
                  )}
                  options={staticConfig.trueOrFalseData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.nationalCode} name="nationalCode">
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.nationalCode
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.instWhereClientMoneyIsPaid}>
                    {BOM.SubstringFormat(
                      labelConfig.instWhereClientMoneyIsPaid,
                      20
                    )}
                  </Tooltip>
                }
                name="hasClientMoney"
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.instWhereClientMoneyIsPaid} *`,
                    "select"
                  )}
                  options={staticConfig.trueOrFalseData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.frequencyInternal}>
                    {BOM.SubstringFormat(labelConfig.frequencyInternal, 20)}
                  </Tooltip>
                }
                name="internalClientReconFrequency"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.frequencyInternal
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip title={labelConfig.frequencyExternal}>
                    {BOM.SubstringFormat(labelConfig.frequencyExternal, 20)}
                  </Tooltip>
                }
                name="externalClientReconFrequency"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.frequencyExternal
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.treasuryDealerLines}
                name="treasuryDealerLines"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.treasuryDealerLines
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

export default EditKYCBusinessInfo;
